import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        reason: String,
    }

    openModal(event) {
        if (event) {
            event.preventDefault()
        }

        $('#contact-customer-service-modal').modal({
            backdrop: 'static',
            focus: false,
            show: true,
        })

        if (this.hasReasonValue && this.reasonValue) {
            this.#setReason(this.reasonValue)
        }
    }

    #setReason(value) {
        const select = document.getElementById('contact-customer-service-reason-input')

        if (select && select.tomselect) {
            select.tomselect.setValue(value, true)
        }
    }
}
